import request, { METHODS } from "src/utils/api-base";

const categoryApis = {
  // Create new category
  createCategory: (payload: any) => {
    return request({
      route: "/app/categories",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },

  // Get category list (paginated)
  getCategoryList: (params: {
    page: number;
    limit: number;
    search?: string;
    status?: "active" | "inactive";
  }) => {
    return request({
      route: "/app/categories",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  // Edit category
  editCategory: (payload: any) => {
    return request({
      route: `/app/categories/${payload._id}`,
      method: METHODS.PUT,
      payload,
      auth: true,
    });
  },

  // Delete category
  deleteCategory: (_id: string) => {
    return request({
      route: `/app/categories/${_id}`,
      method: METHODS.DELETE,
      auth: true,
    });
  },

  // Delete subcategory
  deleteSubCategory: (payload: { categoryId: string; subCategoryId: string }) => {
    return request({
      route: `/app/categories/${payload.categoryId}/subcategories/${payload.subCategoryId}`,
      method: METHODS.DELETE,
      auth: true,
    });
  },

  // Bulk-create categories (and sub-categories) from parsed spreadsheet rows
  bulkImport: (rows: Array<Record<string, any>>) => {
    return request({
      route: "/app/categories/bulk-import",
      method: METHODS.POST,
      payload: { rows },
      auth: true,
    });
  },
};

export default categoryApis;
